import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=63bc8fd8"
import script from "./EditCard.vue?vue&type=script&lang=js"
export * from "./EditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports